import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "streamthumb-auth-token";

export const api = axios.create({
  baseURL: `${BASE}/api`,
});

export const apiBaseUrl = `${BASE}/api`;

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const login = async (password) => {
  const { data } = await api.post("/auth/login", { password });
  setToken(data.token);
  return data.token;
};

export const verify = async () => {
  try {
    await api.get("/auth/verify");
    return true;
  } catch {
    return false;
  }
};

export const logout = () => {
  clearToken();
};

/**
 * Build an absolute URL for a media file that includes the auth token as a
 * query param so it works in <img> tags without an Authorization header.
 */
export const mediaUrl = (src) => {
  if (!src) return "";
  // Pass-through: data URLs and absolute http(s) URLs need no transformation.
  if (src.startsWith("data:") || src.startsWith("http")) return src;
  const token = getToken();
  // Server media route: prepend API host and add ?auth= so <img> tags work.
  const stripped = src.startsWith("/api") ? src.slice(4) : src;
  return `${apiBaseUrl}${stripped}${token ? `?auth=${encodeURIComponent(token)}` : ""}`;
};
